import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from "./locales/en.json";
import { fr } from "./locales/fr.json";
import { nl } from "./locales/nl.json";


const options = {
    interpolation: {
        escapeValue: false,
    },

    resources: {
        en: {
            common: en,
        },
        fr: {
            common: fr,
        },
        nl: {
            common: nl,
        }
    },
    fallbackLng: 'en',

    ns: ['common'],

    defaultNS: 'common',

    react: {
        wait: false,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    },
    detection: {
        order: ['querystring', 'localStorage', 'navigator'],
        lookupQuerystring: 'lang'
    },

};


i18n
    .use(LanguageDetector) // passes i18n down to react-i18next
    .use(initReactI18next)
    .init(options);

export default i18n;